export const getInitialValues = {
  lastName: '',
  firstName: '',
  dateOfBirth: '',
  postalCode: '',
  city: '',
  email: '',
};
